<template>
    <div class="tabs" ref="tabs">
      <div class="titles">
        <div
          v-for="item in tabItems"
          :key="item.name"
          @click="selectTab(item)"
          class="title"
          :class="{ selected: item.isActive }"
          tabindex="0">
          {{ item.name }}
        </div>
      </div>
    </div>
  </template>
    
  <script>
  import { TabGroup } from '@eds/vanilla';
  
  export default {
    name: 'TabsGenericComponent',
    
    props: {
      tabItems: {
        type: Array,
        required: true,
      },
    },
  
    mounted() {
      if (!!this.tabItems[0]) {
        this.tabItems[0].isActive = true;
      }
  
      this.initTabs();
    },
  
    methods: {
      selectTab(item) {
        if (item.isActive) {
          return;
        }

        this.setActive(item.name);

        this.$emit('changeValue', item.name);
      },

      setActive(itemName) {
        this.tabItems.forEach(tabItem => {
          tabItem.isActive = tabItem.name === itemName;
        });
      },
  
      initTabs() {
        const tabs = this.$refs.tabs;
  
        if (tabs) {
          Array.from(tabs).forEach((tabDOM) => {
            const tabGroup = new TabGroup(tabDOM);
            tabGroup.init();
          });
        }
      },
    },
  };
  </script>
    
  <style lang="less" scoped></style>